import ModalForm from 'components/commons/modal-form'
import { InlineError, Input, Spinner } from 'avo-ui'
import MultipleSelect from 'components/commons/multiple-select'

export const FormProductType = ({
    show,
    onHideForm,
    dataProductType,
    isLoading,
    isLoadingDetail,
    optionsProduct,
    onSearchProduct,
    onChangeForm,
    errorForm,
    onSubmit,
}) => {
    return (
        <ModalForm
            className={'!w-[450px]'}
            classNameContent={'!max-h-[500px] overflow-auto'}
            show={show}
            onHide={onHideForm}
            title={`${!dataProductType?.id ? 'Create' : 'Update'} Product Type`}
            isLoading={isLoading}
            isDisabled={isLoadingDetail}
            onSubmit={onSubmit}
        >
            {isLoadingDetail ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <div className={'flex flex-col space-y-6 px-8 py-2 mb-2'}>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90 required'}>Nama Tipe Produk</div>
                        <Input
                            className={'flex-1'}
                            name={'name'}
                            placeholder={'Masukkan nama tipe produk'}
                            value={dataProductType?.name}
                            onChange={onChangeForm}
                        />
                        <InlineError className='mt-2' message={errorForm?.name} />
                    </div>
                    <div className={'flex-1 flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90'}>Deskripsi</div>
                        <Input
                            type={'text-area'}
                            className={'flex-1'}
                            name={'description'}
                            placeholder={'Masukkan deskripsi'}
                            value={dataProductType?.description}
                            row={5}
                            onChange={onChangeForm}
                        />
                        <InlineError className='mt-2' message={errorForm?.description} />
                    </div>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90'}>Pilih Produk</div>
                        <MultipleSelect
                            optionsClassName={'!w-[85%]'}
                            name={'product_ids'}
                            placeholder={'Search Product...'}
                            onSearch={onSearchProduct}
                            value={dataProductType?.product_ids}
                            options={optionsProduct}
                            onChange={onChangeForm}
                        />
                        <InlineError className='mt-2' message={errorForm?.product_ids} />
                    </div>
                </div>
            )}
        </ModalForm>
    )
}
